import React from "react";
import { useState } from "react";
import { writeContract, getNetwork } from '@wagmi/core'
import { getFirstEditionNFTAddress } from '../../constants/addressBook'
import articleNFTABI from '../../abis/articleNFTABI'
import { minterRole } from "../../constants/roles";

export const RemoveMinterFirstEditionNFT
: React.FC = () => {
  const [newMinter, setnewMinter] = useState("");

  return (
    <div>
      <label>Remove a Minter Permission
      <form>
        <label>Old Minter
          <input
            type="text" 
            value={newMinter}
            onChange={(e) => setnewMinter(e.target.value)}
          />
        </label>
      </form>
      <button onClick={async () => {
        const network = await getNetwork()
        console.log(network.chain?.name)
        const firstEditionNFTAddress = getFirstEditionNFTAddress(network.chain?.name)
        writeContract({
          address: firstEditionNFTAddress,
          abi: articleNFTABI,
          functionName: "revokeRole",
          args: [minterRole, newMinter]
        })
      }}>Submit</button>
      </label>
      <br/>
      <br/>
    </div>
  )
}